<nz-table
    #overviewTable
    [nzData]="data.list"
    [nzLoading]="data.loading"
    [nzFrontPagination]="false"
    nzTableLayout="fixed">
    <thead>
        <tr>
            <th>
                {{ 'relation-relation.fields.id' | translate }}
            </th>
            <th>
                {{ 'relation-relation.fields.company' | translate }}
            </th>
            <th>
                {{ 'relation-relation.fields.name' | translate }}
            </th>
            <th>
                {{ 'relation-relation.fields.type' | translate }}
            </th>
            <th
                nzWidth="120px"
                claimDirective
                [claims]="[
                    {
                        claimType: ClaimTypes.Activity,
                        claimValues: [ClaimValues.Read, ClaimValues.Delete]
                    }
                ]"></th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let row of data.list; let i = index">
            <tr cdkDrag [cdkDragData]="row" [cdkDragDisabled]="!draggingEnabled">
                <td>
                    <a [routerLink]="['/relaties/detail', row.relatedRelationId]" target="_blank">
                        {{ row.relatedRelationId.toString() | truncateText }}
                    </a>
                </td>
                <td>{{ row.companyName| truncateText }}</td>
                <td>
                    {{ row.name | truncateText }}
                </td>
                <td>{{ relationshipTypeMapping[row.relationShipType] | translate }}</td>
                <td>
                    <div class="table-actions">
                        <button
						claimDirective
						[claims]="[
							{
								claimType: ClaimTypes.Relation,
								claimValues: [ClaimValues.Delete]
							}
						]"
						nz-button
						nzDanger
						nzType="text"
						nzShape="circle"
						nz-popconfirm
						nzOkDanger
						[nzPopconfirmTitle]="'notification.delete' | translate"
						[nzOkText]="'common.delete' | translate"
						[nzCancelText]="'common.cancel' | translate"
						[nzIcon]="templateIconDelete"
						nzPopconfirmPlacement="left"
						(nzOnConfirm)="delete.emit(row.id)">
						<i class="fa-regular fa-trash-can"></i>
					</button>
                    </div>
                </td>
            </tr>
        </ng-container>
    </tbody>
</nz-table>
<ng-template #templateIconDelete>
    <i nz-typography nzType="danger" class="fa-regular fa-trash-can"></i>
</ng-template>
